module.exports = __webpack_public_path__ + "static/media/Summerland_Main.af3520aa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Summerland_Main.webp
// module id = ./src/assets/Summerland_Main.webp
// module chunks = 0